import React, { useState } from "react";
import "../../assets/css/home-page/contact.css";
export default function Contact() {
  const [fields, setFields] = useState({
    clientName: "",
    firmIdentity: "",
    contactMail: "",
    classification: "NP3 Class Medium Duty",
    linearMeters: "",
    projectScope: "",
  });

  const handleFormSubmission = (e) => {
    e.preventDefault();
    alert(
      `Quotation parameters for ${fields.linearMeters} linear meters recorded. A structural estimator will contact your corporate engineering office.`,
    );
  };

  return (
    <section id="contact" className="contact-portal-section">
      <div className="container-fluid contact-grid-configuration">
        <div className="portal-informational-side animate-on-scroll">
          <h3>Initiate Technical Procurement</h3>
          <p>
            Submit your design specifications, wall thickness requirements, and
            structural caging profiles to our estimating team for a
            comprehensive cost breakdown.
          </p>

          <div className="office-contact-registry">
            <div className="registry-node">
              <h5>Central Estimating Office:</h5>
              <p>
                pattom palace, 71, Road, Gowreesapattom, Pattom, mangalore,
                Karnataka 695004
              </p>
            </div>
            <div className="registry-node">
              <h5>Direct B2B Pipeline:</h5>
              <p>
                Phone:+91 96005 44451
                <br />
                Email: info@mangalorerccpipes.in
              </p>
            </div>
          </div>
        </div>

        <div className="portal-interactive-form-side animate-on-scroll">
          <form onSubmit={handleFormSubmission} className="b2b-contract-form">
            <div className="form-double-row">
              <div className="field-wrapper">
                <label>Contact Official Name</label>
                <input
                  type="text"
                  required
                  value={fields.clientName}
                  onChange={(e) =>
                    setFields({ ...fields, clientName: e.target.value })
                  }
                />
              </div>
              <div className="field-wrapper">
                <label>Corporate / Agency Entity</label>
                <input
                  type="text"
                  required
                  value={fields.firmIdentity}
                  onChange={(e) =>
                    setFields({ ...fields, firmIdentity: e.target.value })
                  }
                />
              </div>
            </div>

            <label>Official Electronic Mail</label>
            <input
              type="email"
              required
              value={fields.contactMail}
              onChange={(e) =>
                setFields({ ...fields, contactMail: e.target.value })
              }
            />

            <div className="form-double-row">
              <div className="field-wrapper">
                <label>Target Pipe Class Requirement</label>
                <select
                  value={fields.classification}
                  onChange={(e) =>
                    setFields({ ...fields, classification: e.target.value })
                  }
                >
                  <option>NP2 Class Light Drainage</option>
                  <option>NP3 Class Highway Crossing</option>
                  <option>NP4 Class Heavy Runway/Railway</option>
                  <option>Custom Engineering Specifications</option>
                </select>
              </div>
              <div className="field-wrapper">
                <label>Required Volume (Linear Meters)</label>
                <input
                  type="number"
                  required
                  placeholder="e.g., 1200"
                  value={fields.linearMeters}
                  onChange={(e) =>
                    setFields({ ...fields, linearMeters: e.target.value })
                  }
                />
              </div>
            </div>

            <label>Project Scope & Delivery Timelines</label>
            <textarea
              rows="4"
              placeholder="Detail any unique burial depths, soil chemistry profiles, or specific delivery schedules..."
              value={fields.projectScope}
              onChange={(e) =>
                setFields({ ...fields, projectScope: e.target.value })
              }
            ></textarea>

            <button type="submit" className="form-submission-trigger">
              Request Formal Cost Schedule
            </button>
          </form>
        </div>
      </div>
    </section>
  );
}
